import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import InputStyles from './InputStyles';

interface InputUIProps {
  height?: 'large' | 'small';
  width?: number;
  align?: 'center';
  hasError?: boolean;
}

const Input = styled.input<InputUIProps>`
  ${InputStyles}

  ${({ width }) =>
    width &&
    css`
      width: ${toRem(width)};
    `}

  ${({ height }) =>
    height === 'small' &&
    css`
      height: ${toRem(theme.input.height.small)};
    `}

  ${({ align }) =>
    align &&
    css`
      text-align: ${align};
    `}
`;

export default Input;
